import script from "./LiveSportEventView.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveSportEventView.vue?vue&type=script&setup=true&lang=js"

import "./LiveSportEventView.vue?vue&type=style&index=0&id=267cca08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-267cca08"]])

export default __exports__